/**
 * `/login` — one `RouteObject`, so the file is `login.route.tsx` (singular).
 *
 * Unguarded and inside the auth half-shell. It resolves nothing and fetches
 * nothing: **no `loader` in this repo performs a data read**, because a
 * fetching loader would create a cache TanStack Query does not know about and
 * the two would drift on every mutation.
 *
 * The chunk splits through the router's OWN `lazy` rather than `React.lazy`:
 * the data router awaits it before rendering the match, so the feature needs
 * no `Suspense` boundary of its own. It lands in `chunk-auth`, which is never
 * fetched on a signed-in route.
 */
import type { RouteObject } from 'react-router-dom';

export const loginRoute: RouteObject = {
  path: '/login',
  lazy: async () => {
    const { LoginPage } = await import('./LoginPage');
    return { Component: LoginPage };
  },
};
